export default "__VITE_ASSET__45231fea__"